<div class="container-fluid title pt-2 pb-1">
    <h2>TytusX</h2>
</div>
<div class="btn-toolbar" role="toolbar">
    <div class="mb-2 btn-group">
        <div class="dropdown">
            <button class="btn btn-dark rounded-0" type="button" id="dropdownMenu" data-toggle="dropdown"
                aria-haspopup="flase" aria-expanded="false">
                Abrir
            </button>
            <div class="dropdown-menu rounded-0 bg-dark">
                <button (click)="openDialog(1)" class="dropdown-item text-white item" type="button">XML</button>
                <input id="fileInput1" type="file" style="display:none" accept=".xml" (change)="readFile($event,1)"
                    [(ngModel)]="fname[0]">
                <button (click)="openDialog(2)" class="dropdown-item text-white item" type="button">XQuery</button>
                <input id="fileInput2" type="file" style="display:none" (change)="readFile($event,2)"
                    [(ngModel)]="fname[1]">
                <button (click)="openDialog(3)" class="dropdown-item text-white item" type="button">Código 3D</button>
                <input id="fileInput3" type="file" style="display:none" accept=".c" (change)="readFile($event,3)"
                    [(ngModel)]="fname[2]">
            </div>
        </div>
        <div class="dropdown">
            <button class="btn btn-dark rounded-0 " type="button" id="dropdownMenu" data-toggle="dropdown"
                aria-haspopup="flase" aria-expanded="false">
                Guardar
            </button>
            <div class="dropdown-menu rounded-0 bg-dark">
                <button (click)="saveFile(1)" class="dropdown-item text-white item" type="button">XML</button>
                <button (click)="saveFile(2)" class="dropdown-item text-white item" type="button">XQuery</button>
                <button (click)="saveFile(3)" class="dropdown-item text-white item" type="button">Traducción</button>
            </div>
        </div>
        <button (click)="newTab()" type="button" class="btn btn-dark rounded-0">Nueva pestaña</button>
        <button (click)="closeTab()" type="button" class="btn btn-dark rounded-0">Cerrar pestaña</button>
        <div class="dropdown">
            <button class="btn btn-dark rounded-0 " type="button" id="dropdownMenu" data-toggle="dropdown"
                aria-haspopup="flase" aria-expanded="false">
                Limpiar
            </button>
            <div class="dropdown-menu rounded-0 bg-dark">
                <button (click)="cleanEditor(1)" class="dropdown-item text-white item" type="button">XML</button>
                <button (click)="cleanEditor(2)" class="dropdown-item text-white item" type="button">XQuery</button>
                <button (click)="cleanEditor(3)" class="dropdown-item text-white item" type="button">Traducción</button>
            </div>
        </div>
        <div class="dropdown">
            <button class="btn btn-dark rounded-0 dropdown-toggle" type="button" id="dropdownMenu"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Reportes
            </button>
            <div class="dropdown-menu rounded-0 bg-dark">
                <button (click)="getAST()" class="dropdown-item text-white item" type="button">AST</button>
                <button (click)="getCST()" class="dropdown-item text-white item" type="button">CST</button>
                <button (click)="getC3D()" class="dropdown-item text-white item" type="button">C3D</button>
                <button (click)="getGrammarReport()" class="dropdown-item text-white item"
                    type="button">Gramatical</button>
            </div>
        </div>
    </div>
    <div class="btn-group sel_g" role="group">
        <select id="grammar_selector" class="form-select btn btn-dark rounded-0">
            <option disabled>Seleccione gramática</option>
            <option selected value="1">Ascendente</option>
            <option value="2">Descendente</option>
        </select>
    </div>
</div>


<div class="container-fluid px-5 pt-2">

    <form #iForm="ngForm" class="mb-4" (ngSubmit)="onSubmit()" novalidate>

        <div class="row mb-5 file-query">
            <div class="col-10">
                <p class="my-0 text-white subtitulo">&nbsp;Editor de consultas</p>
                <ngx-monaco-editor id="consulta" name="consulta" class="" [options]="QueryOptions"
                    [(ngModel)]="consulta">
                </ngx-monaco-editor>
            </div>
            <div class="col-2 align-self-center">
                <button type="submit" class="btn mt-5 btn-outline-light boton btn-lg"><i class="fas fa-code"></i>
                    EJECUTAR</button>
                <button type="button" (click)="codigoIntermedio()" class="btn mt-3 btn-outline-light boton btn-lg"><i
                        class="fas fa-language"></i>
                    TRADUCIR</button>
            </div>
        </div>

        <div class="row mb-5 file-editors">
            <div class="col-lg-6 col-sm-12">
                <p class="my-0 text-white subtitulo">&nbsp;Entrada XML</p>
                <ngx-monaco-editor id="entrada" name="entrada" class="codebox" [options]="XMLOptions"
                    [(ngModel)]="entrada">
                </ngx-monaco-editor>
            </div>

            <div class="col-lg-6 col-sm-12">
                <p class="my-0 text-white subtitulo">&nbsp;Consola de salida</p>
                <ngx-monaco-editor id="salida" name="salida" class="codebox" [options]="ConsoleOptions"
                    [(ngModel)]="salida">
                </ngx-monaco-editor>
            </div>
        </div>


        <div class="row pt-3">
            <div class="col-6">
                <p class="my-0 text-white subtitulo_t">Traducción</p>
            </div>
            <div class="col-6 text-right">
                <button (click)="optimizarC3D()" type="button" class="btn btn-dark rounded-0 text-right"><i
                        class="fas fa-broom"></i>
                    OPTIMIZAR</button>
            </div>
        </div>

        <div class="row mb-5 file-console">
            <div class="col-12">
                <ngx-monaco-editor id="traduccion" name="traduccion" class="codebox" [options]="C3DOptions"
                    [(ngModel)]="traduccion">
                </ngx-monaco-editor>
            </div>
        </div>

    </form>

    <br>
    <hr>

    <div class="row my-5">
        <div class="col-12">
            <p class="my-1 text-white subtitulo">Tabla de símbolos</p>
            <table class="table table-striped table-dark">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Id</th>
                        <th scope="col">Tipo</th>
                        <th scope="col">Contenido</th>
                        <th scope="col">Ámbito</th>
                        <th class="text-center" scope="col">Fila</th>
                        <th class="text-center" scope="col">Columna</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of simbolos; let i = index">
                        <th scope="row">{{i+1}}</th>
                        <td>{{item.id}}</td>
                        <td>{{item.tipo}}</td>
                        <td>{{item.value}}</td>
                        <td>{{item.entorno}}</td>
                        <td class="text-center">{{item.linea}}</td>
                        <td class="text-center">{{item.columna}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <hr>

    <div class="row my-5">
        <div class="col-12">
            <p class="mt-2 mb-1 text-white subtitulo">Tabla de errores</p>
            <table class="table table-striped table-dark">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Tipo</th>
                        <th scope="col">Error</th>
                        <th scope="col">Origen</th>
                        <th class="text-center" scope="col">Fila</th>
                        <th class="text-center" scope="col">Columna</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of errores; let i = index">
                        <th scope="row">{{i+1}}</th>
                        <td>{{item.tipo}}</td>
                        <td>{{item.error}}</td>
                        <td>{{item.origen}}</td>
                        <td class="text-center">{{item.linea}}</td>
                        <td class="text-center">{{item.columna}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

</div>

<footer class="text-center text-lg-start">
    <div class="text-center p-3" style="background-color: rgba(0, 0, 0, 0.2);">
        <p class="foot my-0">
            © 2021 Grupo 23 - Organización de Lenguajes y Compiladores 2 - TytusX
        </p>
    </div>
</footer>